import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getData } from "../../../api/Interface";
import { logoutUser, openNotificationWithIcon } from "../../../Helper";
import { PublicAPIRoutes } from "../../../api/APIRoutes";

import { Popover } from "antd";
// import { button } from "antd";
import { Badge } from "antd";

const Access = ({ userData, setUserData }) => {
  let location = useLocation();
  const history = useHistory();

  const [isNotifPopoverVisible, setIsNotifPopoverVisible] = useState(false);
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const [notifications, setNotifications] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (
      localStorage.getItem("zibatran-user-data") &&
      JSON.parse(localStorage.getItem("zibatran-user-data")).access_token !== ""
    ) {
      setUserData(JSON.parse(localStorage.getItem("zibatran-user-data")));
      getNotifications();
    }
  }, [location]);

  const getNotificationDetail = async (id) => {
    setLoading(true);
    openNotificationWithIcon("info", "درحال انتقال", "لطفا منتظر باشید...");
    let response = await getData(PublicAPIRoutes.GetNotifications + id);
    if (response && response.data && response.data.notification_data && userData) {
      let nData = await response.data.notification_data;
      setIsNotifPopoverVisible(!isNotifPopoverVisible);

      if (
        userData.user_data.roles[0].name.toLowerCase() === "student" ||
        userData.user_data.roles[0].name.toLowerCase() === "studentparent"
      ) {
        if (response.data.notification.type.indexOf("CreateSessionNotification") > -1) {
          history.push(
            `/dashboard/main/classrooms/${encodeURIComponent(nData.grade.name)}/${encodeURIComponent(
              nData.school.code
            )}/${encodeURIComponent(nData.classroom.code)}/${encodeURIComponent(
              nData.classroom.name
            )}/lessons/${encodeURIComponent(nData.lesson.code)}/sessions/${encodeURIComponent(nData.code)}/session`
          );
        }

        if (response.data.notification.type.indexOf("QuestionNotification") > -1) {
          history.push(
            `/dashboard/main/classrooms/${encodeURIComponent(nData.grade.name)}/${encodeURIComponent(
              nData.school.code
            )}/${encodeURIComponent(nData.classroom.code)}/${encodeURIComponent(
              nData.classroom.name
            )}/lessons/${encodeURIComponent(nData.lesson.code)}/sessions/${encodeURIComponent(nData.code)}/session`
          );
        }

        if (response.data.notification.type.indexOf("Message") > -1) {
          history.push(
            `/dashboard/main/messages/${encodeURIComponent(nData.school.name)}/${encodeURIComponent(
              nData.school.id
            )}/list`
          );
        }
      } else {
        if (response.data.notification.type.indexOf("HomeworkNotification") > -1) {
          history.push(
            `/dashboard/main/lessons/${encodeURIComponent(nData.classroom.school.name)}/${encodeURIComponent(
              nData.classroom.school.code
            )}/${encodeURIComponent(nData.lesson.code)}/${encodeURIComponent(
              nData.lesson.title
            )}/sessions/${encodeURIComponent(nData.session.code)}/homeworks/${encodeURIComponent(nData.code)}/homework`
          );
        }
        if (response.data.notification.type.indexOf("QuestionNotification") > -1) {
          history.push(
            `/dashboard/main/lessons/${encodeURIComponent(nData.school.name)}/${encodeURIComponent(
              nData.school.code
            )}/${encodeURIComponent(nData.lesson.code)}/${encodeURIComponent(
              nData.lesson.title
            )}/sessions/${encodeURIComponent(nData.session.code)}/session`
          );
        }
        if (response.data.notification.type.indexOf("Message") > -1) {
          history.push(
            `/dashboard/main/messages/${encodeURIComponent(nData.school.name)}/${encodeURIComponent(
              nData.school.id
            )}/list`
          );
        }
      }
    }
    setLoading(false);
  };

  const navigate = async (route) => {
    await setIsPopoverVisible(!isPopoverVisible);
    history.push(route);
  };
  const getNotifications = async () => {
    let response = await getData(PublicAPIRoutes.GetNotifications);
    if (response && response.data) {
      setNotifications(response.data);
    }
  };

  return (
    <div className="access d-flex flex-nowrap mx-5">
      {userData && (
        <Popover
          content={
            userData &&
            userData.user_data.roles.length > 0 &&
            userData.user_data.roles[0].name.toLowerCase() === "student" ? (
              <div className="floatingMenuContainer">
                <span
                  onClick={() => {
                    navigate("/dashboard/main");
                  }}
                >
                  ورود به پیشخوان
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/wallet");
                  }}
                >
                  کیف پول
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/followers");
                  }}
                >
                  دنبال کننده ها
                </span>
                <span
                  onClick={() => {
                    navigate("/event-list");
                  }}
                >
                  ثبت نام رویداد
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/event/purchased");
                  }}
                >
                  رویداد های ثبت نام شده
                </span>

                <span
                  onClick={() => {
                    logoutUser();
                  }}
                >
                  خروج از حساب
                </span>
              </div>
            ) : userData &&
              userData.user_data.roles.length > 0 &&
              userData.user_data.roles[0].name.toLowerCase() === "studentparent" ? (
              <div className="floatingMenuContainer">
                <span
                  onClick={() => {
                    navigate("/dashboard/main");
                  }}
                >
                  ورود به پیشخوان
                </span>

                <span
                  onClick={() => {
                    logoutUser();
                  }}
                >
                  خروج از حساب
                </span>
              </div>
            ) : userData &&
              userData.user_data.roles.length > 0 &&
              userData.user_data.roles[0].name.toLowerCase() === "adviser" ? (
              <div className="floatingMenuContainer">
                <span
                  onClick={() => {
                    navigate("/dashboard/main");
                  }}
                >
                  ورود به پیشخوان
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/profile");
                  }}
                >
                 پروفایل
                </span>

                <span
                  onClick={() => {
                    logoutUser();
                  }}
                >
                  خروج از حساب
                </span>
              </div>
            ) : userData &&
              userData.user_data.roles.length > 0 &&
              userData.user_data.roles[0].name.toLowerCase() === "teacher" ? (
              <div className="floatingMenuContainer">
                <span
                  onClick={() => {
                    navigate("/dashboard/main");
                  }}
                >
                  ورود به پیشخوان
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/wallet");
                  }}
                >
                  کیف پول
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/followers");
                  }}
                >
                  دنبال کننده ها
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/events");
                  }}
                >
                  تعریف رویداد
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/events");
                  }}
                >
                  رویداد های خریداری شده
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/events");
                  }}
                >
                  رویداد های برگزار شده
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/event/purchased");
                  }}
                >
                  رویداد های ثبت نام شده
                </span>
                <span
                  onClick={() => {
                    logoutUser();
                  }}
                >
                  خروج از حساب
                </span>
              </div>
            ) : userData &&
              userData.user_data.roles.length > 0 &&
              userData.user_data.roles[0].name.toLowerCase() === "assistant" ? (
              <div className="floatingMenuContainer">
                <span
                  onClick={() => {
                    navigate("/dashboard/main");
                  }}
                >
                  ورود به پیشخوان
                </span>

                <span
                  onClick={() => {
                    navigate("/dashboard/main/teachers");
                  }}
                >
                  مدرسان
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/students");
                  }}
                >
                  دانش آموزان
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/messages");
                  }}
                >
                  پیام داخلی
                </span>

                <span
                  onClick={() => {
                    logoutUser();
                  }}
                >
                  خروج از حساب
                </span>
              </div>
            ) : userData &&
              userData.user_data.roles.length > 0 &&
              userData.user_data.roles[0].name.toLowerCase() === "manager" ? (
              <div className="floatingMenuContainer">
                <span
                  onClick={() => {
                    navigate("/dashboard/main");
                  }}
                >
                  ورود به پیشخوان
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/jointexam");
                  }}
                >
                  امتحانات مشترک
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/event");
                  }}
                >
                  جلسات و رویداد ها
                </span>
                <span
                  onClick={() => {
                    navigate("/dashboard/main/messages");
                  }}
                >
                  پیام داخلی
                </span>

                <span
                  onClick={() => {
                    navigate("/dashboard/main/editprofile");
                  }}
                >
                  ویرایش اطلاعات
                </span>

                <span
                  onClick={() => {
                    navigate("/dashboard/main/reports");
                  }}
                >
                  گزارشات مدیر
                </span>

                <span
                  onClick={() => {
                    navigate(`/dashboard/main/workbooks/${encodeURIComponent(userData.user_data.manager.school.code)}`);
                  }}
                >
                  کارنامه‌ها
                </span>

                <span
                  onClick={() => {
                    logoutUser();
                  }}
                >
                  خروج از حساب
                </span>
              </div>
            ) : (
              userData &&
              userData.user_data.roles.length > 0 &&
              userData.user_data.roles[0].name.toLowerCase() === "admin" && (
                <div className="floatingMenuContainer">
                  <span
                    onClick={() => {
                      navigate("/admin");
                    }}
                  >
                    ورود به پیشخوان
                  </span>

                  <span
                    onClick={() => {
                      logoutUser();
                    }}
                  >
                    خروج از حساب
                  </span>
                </div>
              )
            )
          }
          placement="bottom"
          visible={isPopoverVisible}
          title={
            <div>
              <i className="fal fa-user" /> <span>{userData && userData.user_data.name}</span>
            </div>
          }
        >
          <button
            onClick={() => {
              setIsPopoverVisible(!isPopoverVisible);
            }}
            type="primary"
            className=" d-flex align-items-center btn-pannel btnPnnel1"
            shape="round"
            icon={null}
            trigger="click"
            size={30}
          ><span className="hoverbtn"></span>
            <i className="fal fa-bars pr-2" />
            <div>
              <span>{userData.user_data.name}</span>
              {' '}
              {/* {console.log(userData.user_data.roles[0])} */}
              <small>
                {userData.user_data.roles[0].name === 'MANAGER' ? '( مدیر )' :
                userData.user_data.roles[0].name === 'ADVISER' ? '( مشاور )' :
                userData.user_data.roles[0].name === 'TEACHER' ? '( معلم )' : ''
                }
              </small>
            </div>

          </button>
        </Popover>
      )}

      {notifications && notifications.length > 0 && (
        <Popover
          content={
            notifications && notifications.length > 0 ? (
              <div style={{ width: "100%", height: 200, overflow: "scroll" }}>
                {notifications.map((val, ind) => {
                  return (
                    <div
                      onClick={() => {
                        if (!loading) {
                          getNotificationDetail(val.id);
                        }
                      }}
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderStyle: "solid",
                        borderWidth: 0,
                        borderColor: "#b6b6b6",
                        borderBottomWidth: 0.1,
                      }}
                      key={ind}
                    >
                      <span className="font-weight-bold p-3">{val.data.title}</span>
                      <span style={{ color: "#949494", fontSize: 10 }}>{val.time}</span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <span style={{ width: "100%", textAlign: "center" }}>اعلانی وجود ندارد</span>
            )
          }
          placement="bottom"
          visible={isNotifPopoverVisible}
          title={
            <div style={{ maxWidth: 400 }}>
              <Badge count={notifications.length} style={{ direction: "ltr" }} size={"small"} offset={[0, -10]} />
              <i className="fal fa-bell" /> <span> اعلانات </span>
            </div>
          }
        >
          <button
            onClick={() => {
              setIsNotifPopoverVisible(!isNotifPopoverVisible);
            }}
            type="primary"
            className=" d-flex align-items-center bell-pannel-btn"
            shape="round"
            icon={null}
            trigger="click"
            size={60}
          ><i className="fa-regular fa-bell fa-bell-btn"></i></button>
        </Popover>
      )}
    </div>
  );
};

export default Access;
